import { TeamData } from 'config/commonTypes';
import React from 'react';
import { useEntitiesState } from 'store/hooks';
import {
  POSITION,
  STATUS,
  OFFICIALS_POSITIONS,
 } from '../../config/constants';

import { getTeamData } from '../../helpers/helpers';
import BasicDropdown from '../Shared/BasicDropdown/BasicDropdown';
import { ExtraDataFormProps, PositionOfficialsType } from './types';

type DropdownProps = {
  group: string;
  position: string;
};

// need to pass the missing functions for this part to be complete.
const DataOpsExtraData =  ({
                  changeNflId, changeFirstName, changeLastName,
                  changeJerseyNumber, changeHeight, changeWeight,
                  changeBirthday,
                  changeCollegeName,
                  changeMiddleName,
                  changeFootballName, changeDisplayName, changeWeek, changeHomeTown,
                  changeCollegeId, changeGsisId, changeSeason, changeSeasonType,
                  changeEsbId, changeCurrentTeamId, changeTeamSeq,
                  entity, extraData, teamId, setExtraData
                } : ExtraDataFormProps) => {
  let teamData:TeamData;
  if (extraData && extraData.teamId !== '') {
    teamData = getTeamData(extraData.teamId)||{} as TeamData;
  } else {
    teamData = getTeamData(teamId)||{} as TeamData;
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const noValueChange = () => {};
  const { isNcaaLeague } = useEntitiesState();
  const entityIsOfficial = entity && entity.type === 'official';

  return (
    <div className="ex-entities">
      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input no-asterisk" required
              value={teamData ? teamData.teamFullName : ''}
              onChange={() => noValueChange()}
            />
            <span className="material-label">Team Full Name</span>
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={extraData && extraData.teamId ? extraData.teamId : teamId}
              onChange={() => noValueChange()}
            />
            <span className="material-label">Team ID</span>
          </div>
        </div>
        <div>
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={teamData ? teamData.teamAbbrName : ''}
              onChange={() => noValueChange()}
            />
            <span className="material-label">Team Abbreviation</span>
          </div>
        </div>
      </div>

      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className={`material-input ${isNcaaLeague? 'no-asterisk' : ''}`} required
              value={extraData && extraData.nflId &&
                //@ts-ignore
              (!isNaN(extraData.nflId) || extraData.nflId === '')
                ? extraData.nflId : ''}
              onChange={(event) => changeNflId(event)}
            />
            <span className="material-label">NFL ID</span>
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={extraData ? extraData.firstName : ''}
              onChange={(event) => changeFirstName(event)}
            />
            <span className="material-label">First Name</span>
          </div>
        </div>
        <div>
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={extraData ? extraData.lastName : ''}
              onChange={(event) => changeLastName(event)}
            />
            <span className="material-label">Last Name</span>
          </div>
        </div>
      </div>

      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input no-asterisk" required
              value={extraData && extraData.middleName ? extraData.middleName : ''}
              onChange={event => changeMiddleName(event)}
            />
            <span className="material-label">Middle Name</span>
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox no-asterisk" id="first-name-input">
            <input
              className="material-input" required
              value={extraData && extraData.footballName ? extraData.footballName : ''}
              onChange={event => changeFootballName(event)}
            />
            <span className="material-label">Football Name</span>
          </div>
        </div>
        <div>
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input no-asterisk" required
              value={extraData && extraData.displayName ? extraData.displayName : ''}
              onChange={event => changeDisplayName(event)}
            />
            <span className="material-label">Display Name</span>
          </div>
        </div>
      </div>

      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={extraData && extraData.jerseyNumber &&
                //@ts-ignore
              (!isNaN(extraData.jerseyNumber) || extraData.jerseyNumber === '')
                ? extraData.jerseyNumber : ''}
              onChange={(event) => changeJerseyNumber(event)}
            />
            <span className="material-label">Jersey #</span>
          </div>
        </div>
        {!entityIsOfficial ?
          <div className="d-entities-t">
            <div className="material-textbox" id="first-name-input">
              <input
                className="material-input no-asterisk" required
                value={extraData ? extraData.height : ''}
                onChange={(event) => changeHeight(event)}
              />
              <span className="material-label">Height</span>
            </div>
          </div> :
          <div style={{width: '231px', position: 'relative'}}>
            <span className="label-select"> Position  </span>
            <b style={{
              position: 'absolute',
              right: '5px',
              top: '-16px',
              color: 'red',
              fontSize: '11px'
            }}>*</b>
            <BasicDropdown
              type={OFFICIALS_POSITIONS}
              selectedType={OFFICIALS_POSITIONS.types.find(type => type.value.position === (extraData && extraData.position))}
              onSelectType={(itemsSelected: PositionOfficialsType) => {
                const newExtraData = JSON.parse(JSON.stringify(extraData));
                newExtraData.position = itemsSelected.value.position;
                newExtraData.positionGroup = itemsSelected.value.group;
                setExtraData(newExtraData);
              }}
            />
          </div>
        }
        <div>
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input no-asterisk" required
              value={extraData ? extraData.weight : ''}
              onChange={(event) => changeWeight(event)}
            />
            <span className="material-label">Weight</span>
          </div>
        </div>
      </div>

      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox">
            <input
              className="material-input no-asterisk"
              value={extraData ? extraData.birthDate : ''}
              onChange={(event) => changeBirthday(event)}
              required
            />
            <span className="material-label">Birthday</span>
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox">
            <input className="material-input" readOnly value={extraData ? extraData.positionGroup : ''} />
            <span className={'material-label ' + (extraData && extraData.positionGroup ? 'in-focus' : 'out-focus')}>
              Position Group
            </span>
          </div>
        </div>
        <div style={{width: '100%', position: 'relative'}}>
            <span className="label-select"> Position  </span>
            <b style={{
              position: 'absolute',
              right: '6px',
              top: '-16px',
              color: 'red',
              fontSize: '11px'
            }}>*</b>
            <BasicDropdown<DropdownProps>
              type={POSITION}
              selectedType={POSITION.types.find(type => type.value.position === (extraData && extraData.position))}
              onSelectType={(itemsSelected:PositionOfficialsType) => {
                const newExtraData = JSON.parse(JSON.stringify(extraData));
                newExtraData.position = itemsSelected.value.position;
                newExtraData.positionGroup = itemsSelected.value.group;
                setExtraData(newExtraData);
              }}
            />
        </div>
      </div>

      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox">
            <input className="material-input no-asterisk" required />
            <span className="material-label">Years of Experience</span> {/*MISSING INPUT HANDLING, */}
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox">
            <input
              className="material-input no-asterisk"
              required
              value={extraData ? extraData.collegeName : ''}
              onChange={event => changeCollegeName(event)}
            />
            <span className="material-label">College Name</span>
          </div>
        </div>
        <div style={{width: '100%', position: 'relative'}}>
            <span className="label-select"> Status </span>
            <b style={{
              position: 'absolute',
              right: '6px',
              top: '-16px',
              color: 'red',
              fontSize: '11px'
            }}>*</b>
            <BasicDropdown
              type={STATUS}
              selectedType={STATUS.types.find(type => type.value === (extraData && extraData.status))}
              onSelectType={(itemsSelected:{name:string; value:string}) => {
                const newExtraData = JSON.parse(JSON.stringify(extraData));
                newExtraData.status = itemsSelected.value;
                setExtraData(newExtraData);
              }}
            />
        </div>
      </div>

      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={''}
              onChange={event => changeWeek(event)}
            />
            <span className="material-label no-asterisk">Week</span>
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={extraData && extraData.homeTown ? extraData.homeTown : ''}
              onChange={event => changeHomeTown(event)}
            />
            <span className="material-label no-asterisk">Home Town</span>
          </div>
        </div>
        <div>
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={extraData && extraData.collegeId ? extraData.collegeId : ''}
              onChange={event => changeCollegeId!(event)}
            />
            <span className="material-label no-asterisk">College ID</span>
          </div>
        </div>
      </div>

      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={extraData && extraData.gsisId ? extraData.gsisId : ''}
              onChange={event => changeGsisId(event)}
            />
            <span className="material-label no-asterisk">Gsis ID</span>
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={extraData && extraData.season ? extraData.season : ''}
              onChange={event => changeSeason(event)}
            />
            <span className="material-label no-asterisk">Season</span>
          </div>
        </div>
        <div>
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={''}
              onChange={event => changeCurrentTeamId!(event)}
            />
            <span className="material-label no-asterisk">Current Team ID</span>
          </div>
        </div>
      </div>

      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={''}
              onChange={event => changeSeasonType(event)}
            />
            <span className="material-label no-asterisk">Season Type</span>
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={extraData && extraData.esbId ? extraData.esbId : ''}
              onChange={event => changeEsbId(event)}
            />
            <span className="material-label no-asterisk">Esb ID</span>
          </div>
        </div>
        <div>
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required
              value={extraData && extraData.teamSeq ? extraData.teamSeq : ''}
              onChange={event => changeTeamSeq(event)}
            />
            <span className="material-label no-asterisk">Team Seq</span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DataOpsExtraData;
